import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from "@angular/router";
import { AuthGuard } from '@core/guards/auth.guard';
import { VideosTutorialPortalComponent } from './pages/videos-tutorial-portal/videos-tutorial-portal.component';
import { VideosComponent } from './pages/videos/videos.component';
import { RootComponent } from './root/root/root.component';



export const routing: ModuleWithProviders = RouterModule.forChild([
  {
    path: "videos",
    component: RootComponent,
    canActivate: [AuthGuard],
    children: [
      { 
        path: '',
        component: VideosComponent,

      },
      { path: "home", component: VideosComponent },
      { path: "videos-tutorial-portal", component: VideosTutorialPortalComponent },
    ]
  }
]);
